module.exports = __webpack_public_path__ + "img/8e2836c3b1eae969465267247df66f48.png";